import lineLineChart from "assets/images/chart-images/line-chart-95.png";

const performanceList = [
        // Response to invitations - None
        {id: "#RITP-L02s", name: "line", chartImage: lineLineChart, disabled: false},
        {id: "#RITP-L02e", name: "line", chartImage: lineLineChart, disabled: false},
];

export default performanceList;
